import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe, Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { element, EventEmitter } from 'protractor';
import { LoginAxaErrorModalComponent } from 'src/app/login-axa-error-modal/login-axa-error-modal.component';
import { MessageModalComponent } from 'src/app/message-modal/message-modal.component';
import { Delivery,  DeliveryReservationAxA, ListUserAddress, PickUpCenter, ScheduleDeliveries, ScheduleDelivery, UserAddress, UserAxA, User_AxA_Address } from 'src/app/_models';
import { AuthenticationService, HeaderService, ListsService, UserService, UtilsService } from 'src/app/_services';
import { BasketService } from 'src/app/_services/basket.service';

declare const $:any;

@Component({
  selector: 'app-delivery-axa',
  templateUrl: './delivery-axa.component.html',
  styleUrls: ['./delivery-axa.component.css']
})
export class DeliveryAxaComponent implements OnInit {

  public user : UserAxA;
  public plannedOrder : boolean;

  public submitted : boolean;
  public sendToForm : FormGroup;
  public sendTo : string;

  public pickupCenterForm : FormGroup;
  public selectedCenter : PickUpCenter;

  public addressForm : FormGroup;
  public userAddresses : ListUserAddress[];
  public selectedAddress : User_AxA_Address;

  public planningForm : FormGroup;
  private scheduleDeliveries : ScheduleDeliveries;
  public scheduleHours : ScheduleDelivery[];
  public selectedHourRange : number;
  public refreshing : boolean = false;
  public debouncer : any;
  public paymentMethod : string = '';

  @ViewChild(MessageModalComponent) messageModal: MessageModalComponent;
  @ViewChild(LoginAxaErrorModalComponent) axaErrorModal : LoginAxaErrorModalComponent;



  constructor(
    public header : HeaderService,
    public auth: AuthenticationService,
    public translate: TranslateService,
    public router : Router,
    public users : UserService,
    public location : Location,
    public spinner : NgxSpinnerService,
    public formBuilder : FormBuilder,
    public dom  : DomSanitizer,
    public utils : UtilsService,
    public listss: ListsService,
    public datePipe : DatePipe,
    private titles : Title,
    private basket : BasketService,
    private toastr : ToastrService
  ) {
    this.header.setHeader(false,false,true, true);
  }


  ngOnInit() {
    this.sendTo = '';
    this.submitted = false;
    this.selectedAddress = null;
    this.selectedCenter = null;

    this.sendToForm = this.formBuilder.group({
      sendTo : ['', Validators.required],
    });

    this.pickupCenterForm = this.formBuilder.group({
      centerid : ['', Validators.required]
    });

    this.addressForm = this.formBuilder.group({
      recid : ['', Validators.required]
    });

    this.planningForm = this.formBuilder.group({
      hourRange: ['', Validators.required],
      observ : []
    });

    this.auth.currentUserAxA.subscribe(user =>{
      this.user = user;

      if (user){
 
        this.userAddresses = this.user.user_AxA_addresses.filter( address => {
          return address.address_details.address_type == 2 && (address.address_details.centre_ClickRecull == '' || address.address_details.centre_ClickRecull == null)
        });

        let primaryAddress = this.user.user_AxA_addresses.find(address =>{
          return address.address_details.isprimary == 1;
        });

        // if (primaryAddress && (primaryAddress.address_details.centre_ClickRecull == null || primaryAddress.address_details.centre_ClickRecull.trim() == '' )){
        //   this.f2.sendTo.setValue('address', {onlySelf:true,  emitEvent : false});
        // }

        // if (primaryAddress && primaryAddress.address_details.centre_ClickRecull && primaryAddress.address_details.centre_ClickRecull != null ){
        //   this.f2.sendTo.setValue('center', {onlySelf:true,  emitEvent : false});
        // }
      }
    });

    this.translate.get('AXA_TITLE').subscribe(translation =>{
      this.titles.setTitle(translation);
    });

  }

  get f2() {
    return this.sendToForm.controls;
  }

  get f3() {
    return this.pickupCenterForm.controls;
  }

  get f4() {
    return this.addressForm.controls;
  }

  get f5() {
    return this.planningForm.controls;
  }


  back(){
    this.location.back();
  }

  onSelectSendTo(){
    this.sendTo = this.f2.sendTo.value;
    this.refreshDeliverySchedule();
  }

  onSelectAddress(message : boolean) {

    this.selectedAddress = this.user.user_AxA_addresses.find( address => {
      return address.recid == this.f4.recid.value;
    });


    if (message){
      this.refreshDeliverySchedule();
    }

    // if (message && this.selectedAddress && this.user.subst_policy == 0){
    //   $('#modal-message-ChangeAddress').modal('show');
    // }
  }

  onSelectPickupCenter(message : boolean) {
    this.selectedCenter =  this.utils.pickupCentersAxA.find( center => {
      return center.centerid == this.f3.centerid.value;
    });


    this.refreshDeliverySchedule();
    // if (message && this.selectedCenter && this.user.subst_policy == 0){
    //   $('#modal-message-ChangeAddress').modal('show');
    // }

  }

  refreshDeliverySchedule ( delivery? : Delivery ){

    const deliveryType : number  = this.sendTo  == 'address' ? 1 : 2;
    const deliveryId : string = this.sendTo == 'address' ? this.f4.recid.value : this.f3.centerid.value;
    let pickupCenter = this.utils.pickupCentersAxA.find((p) => p.centerid.trim() === deliveryId.toString());
    let tiporecogida: number = this.sendTo == 'address' ? 0 : (pickupCenter ? +pickupCenter.TipoRecogida : 0);

    if (deliveryId && deliveryId != '') {
      //console.log(deliveryType + " " + deliveryId + " " + tiporecogida);
      this.basket.getAvailableScheduleAxa( this.user.temp_AxA_id, deliveryType, deliveryId, tiporecogida).subscribe( result => {
        this.scheduleDeliveries = result;
        if (this.scheduleDeliveries && this.scheduleDeliveries.deliveries.length > 0) {
          this.scheduleHours = this.scheduleDeliveries.hours();
        } else {
          this.messageModal.show(this.translate.instant(`BUYAXA.DELIVERY_ERROR`),this.translate.instant(`BUYAXA.NOHOURS`));
          this.scheduleHours = null;
        }
      }, error => {
        this.messageModal.show(this.translate.instant(`BUYAXA.DELIVERY_ERROR`),this.translate.instant(`BUYAXA.NOHOURS`));
        this.scheduleDeliveries = null;
        this.scheduleHours = null;
      });
    } else {
      this.scheduleDeliveries = null;
      this.scheduleHours = null;
    }

  }

  houseOrShop(value : string) {
    
    this.f3.centerid.setValue('');
    this.f4.recid.setValue('');
    this.f5.hourRange.setValue('');
    this.addressForm.markAsPristine()
    this.pickupCenterForm.markAsPristine()
    this.planningForm.markAsPristine()
    this.submitted = false;
    this.selectedAddress = null;
    this.selectedCenter = null;
    this.scheduleDeliveries = null;
    this.scheduleHours = null;
    
    this.sendTo = value;
  }

  loginAxA (){
    let valid : boolean  = false;
    this.submitted = true;
    this.addressForm.updateValueAndValidity();
    this.planningForm.updateValueAndValidity();
    this.pickupCenterForm.updateValueAndValidity();
    if (this.sendTo == 'address') {
      valid =  ! (this.planningForm.invalid || this.addressForm.invalid);
    } else {
      valid = ! (this.planningForm.invalid || this.pickupCenterForm.invalid);
    }
   
    if (!valid){
      return;
    }

    let reservation : DeliveryReservationAxA = new DeliveryReservationAxA();
    reservation.tipo = this.sendTo == 'address' ? 1 : 2;
    reservation.id_tipo =  this.sendTo == 'address' ? this.selectedAddress.recid : this.selectedCenter.centerid;
    reservation.transdate = this.scheduleHours[this.f5.hourRange.value].transdate;
    reservation.fromtime =  this.scheduleHours[this.f5.hourRange.value].fromtime;
    reservation.totime = this.scheduleHours[this.f5.hourRange.value].totime;
    reservation.observacions = this.f5.observ.value;
    reservation.isAxA = true;
    //202506019 inici
    let pickupCenter = this.utils.pickupCentersAxA.find((p) => p.centerid.trim() === reservation.id_tipo.toString());
    reservation.tiporecogida = this.sendTo == 'address' ? 0 : (pickupCenter ? +pickupCenter.TipoRecogida : 0);
    //202506019 final
    //console.log(reservation);
    this.auth.fullLoginAxA(this.user,reservation).subscribe( result =>{
      this.router.navigate(['/']);
    }, error => {
      let arrError : any;
      arrError = error.error;
      //---------Error Modal--------------//
      this.axaErrorModal.close.subscribe(result => {
          if (result){
            this.loginAxA();
          } else{
            this.router.navigate(['/']);
            $('#modal-login').modal('show');
          }
          
      });

      this.axaErrorModal.show(this.translate.instant(`BUYAXA.DELIVERY_ERROR`), arrError);

    });
  }

  // reloadLoginAxa(event:any){
  //   this.axaErrorModal.close.subscribe(x => {
  //     this.loginAxA();
  // });
  // }

}
